import { useEffect } from "react";

import { services } from "@src/dependencies";
import { useApiRequest } from "@utils/http-client";

export const useAllAdvisorRoles = ({ enabled }) => {
  const { trekService } = services;

  const {
    response: data,
    sendRequest: getAllAdvisorRoles,
    loading,
  } = useApiRequest(() => trekService.getAdvisorRoles(), false);

  useEffect(() => {
    if (enabled && !data) {
      getAllAdvisorRoles();
    }
  }, [enabled, data]);

  return { data, loading };
};
